// extracted by mini-css-extract-plugin
export var container = "_s7-0";
export var table = "_s7-2";
export var tableWrapper = "_s7-1";